import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useMemo } from "react";

export const TooltipInfo = () => {
  const tooltipTitle: string = useMemo(() => {
    return "Each day a chat has at least one message sent counts as one conversation. Example: A chat with messages sent on 3 different days = 3 conversations.";
  }, []);

  const tooltipStyle: any = useMemo(
    () => ({
      maxWidth: "293px",
    }),
    [],
  );

  return (
    <Tooltip
      placement="top"
      title={tooltipTitle}
      overlayStyle={tooltipStyle}
      overlayClassName="text-sm"
    >
      <QuestionCircleOutlined className="text-md title logo-cursor" />
    </Tooltip>
  );
};
